<div class="header-content-container">
    <div *ngIf="headerData.banner"
        class="page-banner-image"
        [ngStyle]="{
            'background-image': 'url(' + headerData.banner.src + ')',
            'background-position': headerData.banner.imagePosition
        }"
    >
    </div>

    <div class="careerfair-header-wrapper">
        <div class="header-content careerfair-header">
            <div class="flexbox full_width">
                <div class="header-text">
                    <div class="header-title">
                        <h1>
                            {{ headerData.title }}
                            <span *ngFor="let tag of headerData.tags" [ngClass]="tag.styleClass">
                                {{ tag.label }}
                            </span>
                        </h1>
                    </div>
                    <div class="header-subtitle">
                        <div class="header-subtitle-content">
                            {{ headerData.subtitle }}
                        </div>

                        <div class="align-self-end">
                            <action-buttons
                                [buttonsData]="buttonsData"
                                (buttonClick)="onButtonClick($event)"
                            >
                            </action-buttons>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
